import ExpandableField   from '../../resolve/ExpandableField';
import React, {useState} from 'react';
import CopyButton        from '@/components/CopyButton';

export default function ({ record, mode = "record" }) {
  console.log(record);
  const { ID, ServiceName, ...rest } = record;

  let [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  }


  return (
      <div className="party-record p-4">
        <header>
          <div className="flex justify-between items-center">
            <h1>{ServiceName.DisplayName}</h1>
            <div className="flex justify-between items-center">
              {mode === "card" &&
                  <div className="flex items-center">
                    <a href={`/service/${ID}`} className="mr-2 text-theme-blue">{ID}</a>
                    <CopyButton content={ID} />
                  </div>
              }
              {mode === "card" && <div>
                <button className="flex items-center" onClick={toggle}>
                  <i className="mio">{isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i>
                </button>
              </div>}
            </div>

          </div>
          {mode === "record" &&

              <div className="columns-1xs columns-lg justify-between  mt-2">
                <div className="flex items-center mb-2">
                  <span className="mr-2 text-theme-blue">{ID}</span>
                  <CopyButton content={ID} />
                </div>
                <hr />
              </div>
          }
        </header>
        {(isOpen || mode === "record") &&
            <div className="mt-4">
              <ExpandableField data={{ someData: rest }} canClose={false} defaultOpen />
            </div>

        }
      </div>
  );
}
